import { get } from 'lodash/fp';
import getTime from 'date-fns/get_time';
import addMinutes from 'date-fns/add_minutes';

import { uiDuck } from '../duck';

/**
 * Exact ads count is know only when the location is changed and the init function is called
 * Here we set a ttl to know if the ads to be loaded was triggered by a filters change interaction
 */

export const setExpiryOfFiltersApplied = () =>
  function* () {
    const expiryTime = getTime(addMinutes(Date.now(), 1));

    yield uiDuck.set({ searchAppliedWithFiltersExpiry: expiryTime });
  };

export const getExpiryOfFiltersApplied = get([
  'searchLayout',
  'ui',
  'searchAppliedWithFiltersExpiry',
]);
